/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendStandartProductConversionFieldDto } from '../../models/backend-standart-product-conversion-field-dto';
import { BackendStandartProductConversionFieldRequestDto } from '../../models/backend-standart-product-conversion-field-request-dto';

export interface SalesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body: BackendStandartProductConversionFieldRequestDto;
}

export function salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: SalesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendStandartProductConversionFieldDto>;
    }),
  );
}

salesStandardProductConversionFieldsUpdate$XWwwFormUrlencoded.PATH =
  '/api/sales/standard-product-conversion-fields/{id}/';
